import { render, staticRenderFns } from "./DegreeList.vue?vue&type=template&id=d7cfe154"
import script from "./DegreeList.vue?vue&type=script&lang=js"
export * from "./DegreeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports